module.exports = __webpack_public_path__ + "static/media/brf-logo-white.6d635281.svg";